// @flow
import styled, { css } from "styled-components";
import { opacityIn, opacityOut } from "@fdr/static-ui/Transitions";
import buildColor from "@fdr/static-ui/ColorPalette";
import {
  FromBottomFloating,
  FromBottom,
  FromLeft,
  FromRight,
  FromTop,
  FromFade
} from "./transitions.styled-components";

export const Overlay = styled.div`
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  width: 100%;
  height: 100%;
  z-index: 999;
  overflow: hidden;
  perspective: 1000px;
  transform-style: preserve-3d;
  background-color: ${(props) =>
    props.isTransparent ? "transparent" : buildColor("black", "50")};
  animation: ${(props) => (props.opening ? opacityIn() : opacityOut())} 0.3s
    ease-out;
`;

export const Transitions = {
  bottomFloating: FromBottomFloating,
  bottom: FromBottom,
  left: FromLeft,
  right: FromRight,
  top: FromTop,
  fade: FromFade
};

export const Container = styled.div.attrs((props) => ({
  "data-qa-label": props.qaLabel
}))`
  display: flex;
  flex-direction: column;
  flex: 1 1 auto;
  width: 100%;
  min-height: 0;

  & .iframeOnModal {
    top: 46px;
    position: fixed;
    height: auto;
  }
`;

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1 1 auto;
  overflow-y: auto;
  overflow-scrolling: touch; /* stylelint-disable-line */
  -webkit-overflow-scrolling: touch; /* stylelint-disable-line */
  ${(props) =>
    props.hasSafeArea &&
    css`
      padding-bottom: constant(safe-area-inset-bottom);
      padding-bottom: env(safe-area-inset-bottom);
    `};
  background-color: ${(props) =>
    props.isContentTransparent
      ? buildColor("white", "00")
      : buildColor("white", "100")};
  ${(props) =>
    props.roundedCorners &&
    css`
      border-radius: 0 0 10px 10px;
    `};

  & > :first-child {
    flex: 1 0 auto;
    display: flex;
    flex-direction: column;
  }
`;

export const Footer = styled.div`
  min-height: 64px;
  display: flex;
  background-color: ${buildColor("white", "100")};
  justify-content: center;
  align-items: center;
  width: 100%;
  box-shadow: 0 -2px 5px ${buildColor("grey", "300")};
  z-index: 1000;
  padding: 12px;
  ${(props) =>
    props.hasSafeArea &&
    css`
      padding-bottom: calc(12px + constant(safe-area-inset-bottom));
      padding-bottom: calc(12px + env(safe-area-inset-bottom));
    `};
`;
/* border-top: 1px solid ${buildColor("grey", "300")}; */
